
export class ApiError extends Error {

    constructor(public statusCode: number, message?: string){
        super(message);
    }
}

export class LoginError extends ApiError {

    constructor(statusCode: number, public url?: string){
        super(statusCode);
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./node_modules/sensejs/core/errors.ts